import { ChangeRequestTemplateStatuses } from '@app/modules/change-requests/types/change-request-translatables';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';
import { BadgeColumn } from '@table/classes/badge-column.class';
import { CheckListFilter } from '@table/classes/column-filters/check-list/check-list-filter.class';
import { CellDisplay } from '@table/enums/cell-display.enum';
import { BadgeDisplay } from '@table/interfaces/badge-display.interface';

export class StatusColumn extends BadgeColumn<ChangeRequestTemplate> {
    title = 'change-requests.templateTable.status';
    type: CellDisplay = CellDisplay.badge;
    filters = [
        new CheckListFilter('isActive', [
            { value: 1, label: ChangeRequestTemplateStatuses.active },
            { value: 0, label: ChangeRequestTemplateStatuses.inactive },
        ]),
    ];

    getBadgeDisplay(changeRequestTemplate: ChangeRequestTemplate): BadgeDisplay | undefined {
        if (changeRequestTemplate.isActive) {
            return {
                type: 'success',
                label: ChangeRequestTemplateStatuses.active,
            };
        }

        return {
            type: 'warning',
            label: ChangeRequestTemplateStatuses.inactive,
        };
    }
}
